import { fetchOptions } from './csrf'

export interface AppointmentSetting {
  id: string | null
  enabled: boolean
  shared_calendar: boolean
  allow_double_booking: boolean
  buffer_minutes: number
  created_at: string | null
  updated_at: string | null
}

interface AppointmentSettingResponse {
  appointment_setting: AppointmentSetting
}

interface ErrorResponse {
  errors: string[]
}

export const appointmentSettingsApi = {
  async show(): Promise<AppointmentSetting> {
    const response = await fetch('/api/v1/settings/appointments', fetchOptions())
    if (!response.ok) throw new Error('Failed to load appointment settings')
    const data: AppointmentSettingResponse = await response.json()
    return data.appointment_setting
  },

  async update(params: Partial<Omit<AppointmentSetting, 'id' | 'created_at' | 'updated_at'>>): Promise<AppointmentSetting> {
    const response = await fetch('/api/v1/settings/appointments', {
      ...fetchOptions('PUT'),
      body: JSON.stringify({ appointment_setting: params }),
    })
    if (!response.ok) {
      const data: ErrorResponse = await response.json().catch(() => ({ errors: ['Failed to update settings'] }))
      throw new Error(data.errors.join(', '))
    }
    const data: AppointmentSettingResponse = await response.json()
    return data.appointment_setting
  },
}
